import { bbox } from '3rd-party-wrappers/turf';

/** Calculate boundaries to use in displaying a field within map. */
export const calcMapBounds = ({boundaries, isAppMode, fitBoundsPadding, maxBoundsPadding}) => {
  if (!boundaries) {
    return {fitBounds:null, maxBounds:null};
  }

  function _pad(wsen, padPercent) {
    const halfWidth = (wsen[2] - wsen[0]) / 2;
    const centerX = wsen[0] + halfWidth;
    const halfHeight = (wsen[1] - wsen[3]) / 2;
    const centerY = wsen[3] + halfHeight;
    const paddedHalfWidth = halfWidth * (1 + padPercent);
    const paddedHalfHeight = halfHeight * (1 + padPercent);
    return [
      centerX - paddedHalfWidth,
      centerY - paddedHalfHeight,
      centerX + paddedHalfWidth,
      centerY + paddedHalfHeight
    ];
  }
  const scriptBounds = bbox(boundaries);
  const FIT_BOUNDS_PADDING = isAppMode ? 0 : 0.5; // Set the padding to 0 on mobile, since it looks better
  const MAX_BOUNDS_PADDING = 1.5;
  if (fitBoundsPadding === undefined) { fitBoundsPadding = FIT_BOUNDS_PADDING; }
  if (maxBoundsPadding === undefined) { maxBoundsPadding = MAX_BOUNDS_PADDING; }
  const fitBounds = _pad(scriptBounds, fitBoundsPadding);
  const maxBounds = _pad(scriptBounds, maxBoundsPadding);

  return {fitBounds, maxBounds};
};

/** Calculates centroid of a bounding box, which is trivially calculated as a center point right in the middle.
    It is useful to call this function instead of using a field shape's centroid when you want a centroid that falls
    reliably in the middle of the bounding box despite any quirks of the field's shape.

    @param bounds Turf bounding-box type structure. Same as returned from calcMapBounds().
    @returns Coordinate in [lat, long] format. */
export const calcCentroidFromBounds = (bounds) => {
  const l = bounds[0], t = bounds[1], r = bounds[2], b = bounds[3];
  return [
    t+(b-t)/2, // latitude
    l+(r-l)/2 // longitude
  ];
};
